module.exports = __webpack_public_path__ + "img/pain-sidebar.20f94dc3.svg";